/**
 * products - Data about available menu products.
 * categories - steps to build product in configurator
 * items - items to be added on every step.
 * modifiers - items options to be selected.
 */
export const state = {
  products:   {},
  categories: {},
  items:      {},
  modifiers:  {},
  lazyMenu:   {},
};

export const getters = {
  products:      state => state.products,
  productByKey:  state => productKey => state.products[productKey],
  categories:    state => state.categories,
  categoryByKey: state => categoryKey => state.categories[categoryKey],
  items:         state => state.items,
  itemByKey:     state => itemKey => state.items[itemKey],
  modifiers:     state => state.modifiers,
  modifierByKey: state => modifierKey => state.modifiers[modifierKey],
  lazyMenu:      state => state.lazyMenu,
};

export default {
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/apps/menu/store/state.js